/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Record_PaymentInputs */

const vi_order_record_payment = /** @type {(inputs: Order_Record_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi nhận thanh toán`)
};

/**

* @param {Order_Record_PaymentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_record_payment = /** @type {((inputs?: Order_Record_PaymentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Record_PaymentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_record_payment(inputs)
});